import { AumeLogo } from '@/assets/branding/aume';

const colors = {
  // Brand colors
  brand_primary: '#0779FF',
  brand_primary_hover: '#175CD3',
  brand_primary_highlight: '#84CAFF',
  brand_primary_mid: '#1C86FF',
  brand_primary_dark: '#043E80',
  brand_secondary: '#2F6CCE',
  brand_accent_start: '#1e8dff',
  brand_accent_end: '#7B5CFF',
  brand_accent_light_start: '#e9f5ff',
  brand_accent_light_end: '#ECE6FF',
  brand_complementary_accent: 'rgb(255,150,27)',
  brand_auth_gradient_mid: '#2F6CCE',
  brand_auth_gradient_end: '#043E80',
  brand_auth_warp_mid: '#1C86FF',
};

export default {
  name: 'Aume Media',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AumeLogo,
  colors,
};
